import React, { useState } from 'react';
import { useHistory } from 'react-router';
import { useParams ,NavLink} from 'react-router-dom';
import FeatherIcon from 'feather-icons-react';
import { useTranslation } from 'react-i18next';
import { Row, Col ,Breadcrumb} from 'antd';
import { useSelector } from 'react-redux';

import { BreadcrumbWrapperStyle } from '../../../components/ui-elements/ui-elements-styled';
import { HomeOutlined } from '@ant-design/icons';
import OrchestratorStateList from './OrchestratorStateList';
import { PageHeader } from '../../../components/page-headers/page-headers';
import { Main } from '../styled';
import { Button } from '../../../components/buttons/buttons';
import { Cards } from '../../../components/cards/frame/cards-frame';

const OrchestratorStateManagement = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const [orchestratorName, setOrchestratorName] = useState('');
  const { orchestratorId } = useParams();
  const ChangeLayoutMode = useSelector(state => state.changeLayoutMode.data);
  const darkMode = ChangeLayoutMode;
 
  return (
    <>
      <PageHeader
        ghost
        title={`${t('orchestrator.states.management')} ${orchestratorName.length ? `- ${orchestratorName}` : ''}`}
      />
       <Main darkMode={darkMode}>
       <BreadcrumbWrapperStyle darkMode={darkMode}>
                <Breadcrumb>
                  <Breadcrumb.Item>
                    <NavLink to={`/admin/`}>
                      <HomeOutlined />
                    </NavLink>
                  </Breadcrumb.Item>
                  <Breadcrumb.Item>
                    <NavLink to={`/admin/orchestrator`}>
                      <span> {t('orchestrator.management')}</span></NavLink>
                  </Breadcrumb.Item>
                  <Breadcrumb.Item>
                    <NavLink to="#">{`${t('orchestrator.states.management')} ${orchestratorName.length ? `- ${orchestratorName}` : ''}`}</NavLink>
                  </Breadcrumb.Item>
                </Breadcrumb>
              </BreadcrumbWrapperStyle>
        <Row gutter={15}>
          <Col xs={24}>
            <Cards
              isbutton={
                <div key="6" className="page-header-actions">             
                  <Button
                    key="2"
                    size="small"
                    type="primary"
                    onClick={() => history.push(`/admin/orchestrator/${orchestratorId}/states/create`)}
                    className="btn-signin"
                  >
                    <FeatherIcon icon="plus" size={14} />
                    {t('orchestrator.states.create')}
                  </Button>
                </div>
              }
            >
              <OrchestratorStateList setOrchestratorName={setOrchestratorName} />
            </Cards>
          </Col>
        </Row>
      </Main>
    </>
  );
};

export default OrchestratorStateManagement;
